import apiClient from 'apiClient';
import { ValidationResponse, ValidationStatuses } from './types';

interface Params {
  minimumEquity: number;
  missingAmount: number;
}

interface ResponseData extends Omit<ValidationResponse, 'params'> {}

export class MinimumRemainingEquityValidationError extends Error {
  params: Params;
  status?: string;

  constructor(params: Params, details?: string, status?: string) {
    super(details || 'MinimumRemainingEquityValidationError');
    this.params = params;
    this.status = status;
  }

  isValidationError() {
    return this.status === ValidationStatuses.VALIDATION_ERROR;
  }

  isWarningError() {
    return this.status === ValidationStatuses.WARNING;
  }
}

const validateMinimumRemainingEquity = async (
  loanAmount: number,
  propertyValue: number,
  postCode: string,
): Promise<ResponseData> => {
  const response = await apiClient.post('/api/v1/business-rules/validate-minimum-remaining-equity', {
    loanAmount,
    propertyValue,
    postCode,
  });

  if (response.data.status) {
    if (response.data.status !== ValidationStatuses.OK) {
      throw new MinimumRemainingEquityValidationError(
        response.data.params,
        response.data.details,
        response.data.status,
      );
    }
  } else {
    throw new Error(`Unexpected error occured`);
  }

  return response.data;
};

export default validateMinimumRemainingEquity;
